module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"load_profile":"Load Profile"},"ja":{"load_profile":"プロファイルを読み込み"}}')
  delete Component.options._Ctor
}
